module.exports = __webpack_public_path__ + "img/corporate2.a7248231.png";